<template>
  <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="818px" :before-close="handleClose">
    <div class="">
      <div style="padding: 24px 0;">
        <el-form ref="form-data" :model="form" :inline="false" label-width="150px" label-position="right" :rules="rules"
          style="text-align:left;">
          <el-form-item prop="title" label="广告内容标题">
            <el-input v-model.tirm="form.title" style="width: 400px;" placeholder="请输入" clearable size="small"
            show-word-limit maxlength="50"
              :disabled="isDisabled" />
          </el-form-item> 

          <el-form-item prop="urlTypeId" label="广告图链接地址">
            <div >
              <el-select v-model="form.urlTypeId" clearable style="width: 160px;" size="small" placeholder="请选择链接类型" 
              @change="changeUrlType"
              :disabled="isDisabled">
              <el-option v-for="item in bannerTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
                </el-select>
                <!-- 商户店铺页 -->
                <!-- 商品分类页 -->
                <shopSearchInput v-if="form.urlTypeId == 1 " @chooseShop="chooseShop" ref="shop-search-input" :isDisabled="isDisabled"/>
                <goodsClass    v-else-if="form.urlTypeId == 2 "  @chooseClass="chooseClass" ref="class-select" :isDisabled="isDisabled"/> 
                 
                <span v-else-if="form.urlTypeId == 3 "> 
                   <el-button  style="margin-left: 10px;" size="small" type="primary" @click="handleChooseGoods()" :disabled="isDisabled">选择商品</el-button>
                </span>
               
                <!-- 商品详情页 --> 
                <el-input v-else v-model.tirm="form.value" style="width: 240px;" placeholder="请输入" clearable size="small"
                show-word-limit maxlength="200"
                  :disabled="isDisabled" />
            </div>
            <!-- 选中的商品展示 -->
            <div>
            
              <chooseGoodsItem :records="choiceGoodsItem" v-if="choiceGoodsItem.length>0 && form.urlTypeId == 3"/>
            </div>
          </el-form-item>
          <el-form-item prop="positionName" label="广告位置">
            <el-select v-model="form.positionName" clearable style="width: 400px;" size="small" placeholder="请选择广告位置"
              :disabled="isDisabled" @change="selectPositon">
              <el-option v-for="item in selectedData" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- selectedData -->
          <el-form-item prop="date" label="广告发布时间">
            <el-date-picker style="width: 400px" v-model="form.date" value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
              :disabled="isDisabled" type="datetimerange" size="small" range-separator="-" start-placeholder="开始时间"
              end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" />
          </el-form-item>

          <el-form-item prop="sort" label="广告位排序">
            <el-input v-model.tirm="form.sort" style="width: 400px;" placeholder="请输入" clearable size="small"
            :maxlength="3"
            @keyup.native="proving1"
              :disabled="isDisabled" />
          </el-form-item>
          <el-form-item prop="imageList" label="广告图片">
            <imgUpload v-model="form.imageList" :isEdit="isDisabled" :limit="1" @onRemoveHandler="onRemoveHandler"
              style="position:relative;top:0px;">
              <template slot="tip">
                <p class="el-upload__tip" v-if="form.positionName">
                  推荐图片尺寸：{{ form.width }}* {{ form.height }} 像素，图片大小1M以内,
                  图片格式支持 .jpg、.jpge、.png。
                </p>
              </template>
            </imgUpload>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="success" @click="handleClose()" :disabled="isDisabled">取消</el-button>
            <el-button size="small" type="primary" @click="save()" :disabled="isDisabled">保存草稿</el-button>
            <el-button size="small" type="primary" @click="saveSubmit()" :disabled="isDisabled">保存并发布</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <goodsListDailog   ref="goods-list-dailog" @choiceGoods="choiceGoods"/>  -->
    <DlgAddGoods
      ref="addGoodsRef" 
      @choiceGoods="choiceGoods"
    />
  </el-dialog>
</template>
    
<script>

import { contentManagementSave, positionSettingGetList, contentManagementGetInfo,getCompGoodsBaseDetail } from "@/api/bannerManage";
import avater from "/public/img/default.png";
import imgUpload from '@/components/imgUpload';
import goodsClass from "./goodsClass.vue"
import goodsListDailog from "../goodsDailog/goodsListDailog.vue"
import shopSearchInput from "./shopSearchInput.vue";
import chooseGoodsItem from "../children/chooseGoodsItem.vue"
// import DlgAddGoods from "../../recommendationHome/components/dlgAddGoods";
import DlgAddGoods from "../children/dlgAddGoods"; 
import { getShopGoodsByShopIdList } from "@/api/recommendationHome";

export default {
 
  props: {},
  data() {
    const validateUrl = (rule, value, callback) => {
      if(!this.form.urlTypeId) {
        callback(new Error('请选择链接类型'))
      } else if (!this.form.value) {
        callback(new Error('请输入/选择链接内容'))
      } else {
        callback()
      }
    }
    return {
      avater: avater,
      disabled: false,
      id: '',
      pageType: '',
      isDisabled: false,
      selectedData: [],//广告位下拉列表
      pickerOptions: {
        disabledDate(date) {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          return date.getTime() < Date.now() - 8.64e7;
        }, 
      },
      form: {
        "positionId": '',
        "title": "",
        "image": "",
        "imageList": [],
        "urlTypeId": '',
        "value": "",
        "startTime": "",
        "endTime": "",
        "sort": '',
        "status": "",
        "positionName": "",
        "date": [],
         goodsClassContent:''

      }, 
      optionsClass:[],
      bannerTypeOptions: [
        {
          value: '1',
          label: '商户店铺页'
        },
        {
          value: '2',
          label: '商品分类页'
        },
        {
          value: '3',
          label: '商品详情页'
        },
        {
          value: '4',
          label: '搜索结果页'
        },
        // {
        //   value: '5',
        //   label: '特定商品搜索结果页'
        // },
        // {
        //   value: '6',
        //   label: '专栏页'
        // },
        // {
        //   value: '7',
        //   label: '文章页'
        // },
        {
          value: '8',
          label: '活动页'
        },
        // {
        //   value: '9',
        //   label: '链接地址'
        // },
      ],
      statusOptions: [
        {
          value: 'DRAFT',
          label: '草稿'
        },
        {
          value: 'AWAIT',
          label: '待发布'
        }, {
          value: 'PUBLISHED',
          label: '已发布'
        },
        {
          value: 'REMOVAL',
          label: '已下架'
        },
      ],
      rules: {
        title: [{ required: true, message: '请填写广告内容标题', trigger: 'blur' }],
        imageList: [{ required: true, message: '请上传广告图片', trigger: 'blur' }],
        urlTypeId: [{ required: true, message: '', trigger: 'blur',validator:validateUrl }],
        positionName: [{ required: true, message: '请选择广告位置', trigger: 'change' }],
        sort: [{ required: true, message: '请填写排序', trigger: 'blur' }],
        date: [{ required: true, message: '请选择广告发布时间', trigger: 'change' }],
      },
      title: '',
      visible: false,
      choiceGoodsItem:[],
      showClass:true,
    }
  },
  components: { imgUpload, goodsClass, shopSearchInput ,goodsListDailog ,chooseGoodsItem ,DlgAddGoods},
  created() {

  },
  mounted() {
    
  },
  watch: {},
  methods: { 
    changeUrlType(){
      this.form.value = '';
      this.choiceGoodsItem = [];
    },
    showClassRef(){
      this.showClass = true; 
    },
    // 选择店铺
    chooseShop(e){
      // e[0]  shopId e[1] shopName
     this.form.value = e[0] +',' +e[1];
    },
    // 选择三级分类
    chooseClass(e){ 
      this.form.value = e[0] +',' +e[1] +',' +e[2] +','+ e[3]; 
    },
    choiceGoods(row){ 
      // 选中的商品  // 格式 商品id ,店铺id, skuId 
      this.form.value = row.goodsId +','  + row.shopId+',' + row.skuId ;
      // console.log(this.form.value,'this.form.value')
      this.choiceGoodsItem = [row];
    },
    handleChooseGoods(){ 
      this.$refs.addGoodsRef.dialogVisible = true;
    },
    //验证只能输入正整数
    proving1(){
        this.form.sort=this.form.sort.replace(/[^\.\d]/g,'');
        this.form.sort=this.form.sort.replace('.','');
      },
    onRemoveHandler(file) {
      console.log(file)
    },
    save() {
      this.submit('DRAFT');
    },
    saveSubmit() {
      this.submit('PUBLISHED');
    },

    submit(status) {
      let params = {
        "id": this.form.id
      }
      if (this.form.imageList) {
        this.form.image = this.form.imageList.join(',');
      }
      this.form.startTime = this.form.date?.[0] ?? '';
      this.form.endTime = this.form.date?.[1] ?? '';
      delete params.date;
      params = { ...params, ...this.form };
      params.status = status;
      // console.log(params, '----params')
      // if(!this.form.value){
      //   this.$message.warning('请填写广告图链接地址')
      //   return
      // }
      this.$refs['form-data'].validate((valid) => {
        if (valid) {
          contentManagementSave(params).then((res) => {
            if (res) {
              this.$message.success('提交成功');
              this.$emit('getList')
              this.handleClose();
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },

    selectPositon(row) {
      this.form.positionId = row.id;
      this.form.positionName = row.name;
      this.form.width = row.width;
      this.form.height = row.height;
    },

    handleClose() {
      Object.keys(this.form).forEach((key) => (this.form[key] = ""));
      this.form.imageList = [];
      this.$refs['form-data'].resetFields();
      this.visible = false;
    },
    init(row, type) {
      this.choiceGoodsItem =[];
      this.title = '广告内容管理';
      positionSettingGetList({}).then(res => {
        this.selectedData = res;
      })
      if (type == 'detail') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      if (row && row.id) {
        this.query(row.id);
      } else {
        this.visible = true;
      }
      this.$forceUpdate();
      this.visible = true;
    },

    getGoodsList(params) { 
      getShopGoodsByShopIdList(params).then((res) => {
        if (res.code == 0) {
          const { records, total } = res.data;
          this.choiceGoodsItem = records.slice(0,1); 
        }
      });
    },

    query(id) {
      contentManagementGetInfo(id).then(res => {
        this.form = Object.assign(this.form, res);
        this.form.date = [];
        if (res.startTime) {
          this.form.date.push(res.startTime);
          this.form.date.push(res.endTime);
        }
        if (res.image) {
          this.form.imageList = [res.image];
        }
        console.log(this.form, '---this.form');
        
        this.queryGoodsAndShop();
        this.visible = true;
      })
    },
 
    // urlTypeId ==3  商品详情页
    // 回显查询商品详情数据

    queryGoodsAndShop(){

      // urlTypeId ==3  商品详情页
      if(this.form.urlTypeId ==3){ 
        let valueArr = this.form.value.split(',');
        let params = {}; 
          // params.id = valueArr[2];
          // params.goodsCode = valueArr[0];
          // params.goodsCode = 1674250188351930369;
          params.shopId = valueArr[1]; 
          params.goodsSkuId = valueArr[2];
          params.size = 10;
          params.current = 1; 
        if(params){ 
          this.getGoodsList(params);
        }
      }

      // 商品分类页 urlTypeId ==2
      if(this.form.urlTypeId ==2){   
        this.$nextTick(()=>{
          this.form.goodsClassArr = this.form.value.split(','); 
          let arr = [this.form.goodsClassArr[0],this.form.goodsClassArr[1],this.form.goodsClassArr[2]];  
          this.$refs['class-select'].init(arr) ;
        })
        
      }

      // 商户店铺页 urlTypeId ==1
      if(this.form.urlTypeId ==1){ 
        console.log(this.form.value) 
        this.$nextTick(()=>{ 
          let shopId = this.form.value.split(',')[0];
          let shopName = this.form.value.split(',')[1];
          this.$refs['shop-search-input'].init(shopId,shopName) 
        
        })
      }
      
    },  

  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}

.goods-list-warp {
  width: 100%;
  margin-left: 100px;
  max-height: 500px;
  overflow-y: auto;
}

.goods-list {
  width: 50%;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 10px;

  &:nth-last-child(1) {
    border-bottom: none;
  }
}
.choose-list { 
  width: 400px;
  display: flex;
  justify-content: space-between;
}
</style>
  
  